var classes = {"month":"XpOy6","tableRow":"Yq4Ex"};

export { classes as default };
